// Angular Modules
import { Injectable } from '@angular/core';
import { WebServiceMethod } from '../services/web/web-method';
import { environment } from 'src/environments/environment';
@Injectable()
export class ApiEndPoints {
  public static readonly API_ENDPOINT: string = '/';
  public static readonly CLOUD_BASE_URL: string = environment.cloud_base_url;

  private static readonly AUTH: string =
    ApiEndPoints.API_ENDPOINT + 'identity/auth/';
  private static readonly ADMIN: string =
    ApiEndPoints.API_ENDPOINT + 'identity/admin/';

  public static readonly SET_COOKIE: string = ApiEndPoints.AUTH + 'set_cookie';

  public static readonly SIGN_IN: string = ApiEndPoints.AUTH + 'signin';
  public static readonly SIGN_UP: string = ApiEndPoints.AUTH + 'signup';
  public static readonly CHANGE_PASSWORD:string = ApiEndPoints.AUTH + 'change_password';
  public static readonly FORGOT_PASSWORD: string =
    ApiEndPoints.AUTH + 'forgot_password';
  public static readonly CREATE_ACCOUNT: string =
    ApiEndPoints.AUTH + 'register';
  public static readonly USER_DETAILS: string = ApiEndPoints.AUTH + 'me';
  public static readonly RESET_PASSWORD: string =
    ApiEndPoints.AUTH + 'reset_forgot_password';
  public static readonly REFRESH_TOKEN: string =
    ApiEndPoints.AUTH + 'refresh_token';
  public static readonly SIGNOUT: string = ApiEndPoints.AUTH + 'signout';
  public static readonly USER_LIST: string = ApiEndPoints.AUTH + 'user/list';
  public static readonly UPDATE_USER_STATUS: string =
    ApiEndPoints.AUTH + 'update/status';
  public static readonly UPDATE_USER_DETAILS: string =
    ApiEndPoints.AUTH + 'update_details';
  public static readonly ACCOUNT_DELETE: string =
    ApiEndPoints.AUTH + 'account/delete';
  public static readonly IMAGE: string = ApiEndPoints.AUTH + 'profile/image/';
  public static readonly INSTALLER_LIST: string =
    ApiEndPoints.ADMIN + 'installer/list';
  public static readonly INSTALLER_VIEW_ACCESS: string =
    ApiEndPoints.ADMIN + 'grant/access';

  public static readonly OTP_AUTHENTICATE: string =
    ApiEndPoints.ADMIN + 'authenticate/otp';

  //controller management service
  public static readonly CM_SERVICE_API_ENDPOINT: string = '/cm_service/';


  public static readonly DATA_PROVIDER_API_ENDPOINT: string = '/data/';
  // controller proxy
  private static readonly CONTROLLER: string =
    ApiEndPoints.CM_SERVICE_API_ENDPOINT + 'cm_/controller/';
  // device proxy
  private static readonly DEVICE: string =
    ApiEndPoints.CM_SERVICE_API_ENDPOINT + 'device/';
  // installer proxy
  private static readonly INSTALLER: string =
    ApiEndPoints.CM_SERVICE_API_ENDPOINT + 'installer/';
  private static readonly stream: string =
    ApiEndPoints.INSTALLER + 'stream/controller/';
  //installer
  public static readonly DASHBOARD: string =
    ApiEndPoints.INSTALLER + 'dashboard';
  public static readonly STATUS: string = ApiEndPoints.stream + 'status';
  public static readonly TELEMETRY: string = ApiEndPoints.stream + 'telemetry';
  public static readonly QR: string = ApiEndPoints.stream + 'qr';

  public static readonly ACCESS_LOGGER: string = ApiEndPoints.INSTALLER + 'access'
  public static readonly CONTROLLER_UPDATE_URL:string = ApiEndPoints.ADMIN
  public static readonly CONTROLLER_LIST_URL:string = ApiEndPoints.CM_SERVICE_API_ENDPOINT + "controller/"
  public static readonly DEVICE_LIST_URL:string = ApiEndPoints.CM_SERVICE_API_ENDPOINT + "device/"
  public static readonly DEVICE_STATUS_URL:string = ApiEndPoints.CM_SERVICE_API_ENDPOINT + "device/status/all"
  public static readonly CONTROLLER_INFO:string = ApiEndPoints.CM_SERVICE_API_ENDPOINT + "controller/info"
  public static readonly REBOOT_API:string = ApiEndPoints.CM_SERVICE_API_ENDPOINT + "controller/reboot"
  public static readonly DEVICE_HISTORY_URL:string = ApiEndPoints.DATA_PROVIDER_API_ENDPOINT + "data/history"
  public static readonly DEVICE_TELEMETERY_URL:string = ApiEndPoints.DATA_PROVIDER_API_ENDPOINT + "data/telemetry"
  public static readonly ALARM_HISTORY:string = ApiEndPoints.CM_SERVICE_API_ENDPOINT + "device/alerts"
  public static readonly DEVICE_ACTION_FILTER_URL:string = ApiEndPoints.DATA_PROVIDER_API_ENDPOINT + "data/operation/filters"
  public static readonly DEVICE_ACTION_HISTORY_URL:string = ApiEndPoints.DATA_PROVIDER_API_ENDPOINT + "data/action/history"
  public static readonly DEVICE_STATUS:string = ApiEndPoints.CM_SERVICE_API_ENDPOINT + "device/status"
  public static readonly CONTROLLER_STATUS:string = ApiEndPoints.CM_SERVICE_API_ENDPOINT + "controller/status"


  public static isNeedEncryption(
    url: string,
    method: WebServiceMethod
  ): boolean {
    switch (url) {
      case ApiEndPoints.SIGN_IN:
      case ApiEndPoints.OTP_AUTHENTICATE:
      case ApiEndPoints.UPDATE_USER_DETAILS:
        return true
      case ApiEndPoints.UPDATE_USER_STATUS:
        return true
      case ApiEndPoints.CHANGE_PASSWORD:
        return true
    }
    return false;
  }

  public static isNeedDecryption(
    url: string,
    method: WebServiceMethod
  ): boolean {
    switch (url) {
      case ApiEndPoints.DASHBOARD:
      case ApiEndPoints.USER_LIST:
      case ApiEndPoints.INSTALLER_LIST:
        case ApiEndPoints.DEVICE_ACTION_HISTORY_URL:
        return true;
      case ApiEndPoints.USER_DETAILS:
        return method == WebServiceMethod.Get;
    }
    return false;
  }
}
